import React from 'react'

import { Flex } from 'antd'
import styled from 'styled-components'

import SkipToContent, { MAIN_CONTENT_ID } from 'src/components/SkipToContent/SkipToContent'
import { Logo, LogoColor } from 'src/components/svgs/Logo'
import { useAuthRedirect } from 'src/hooks/use-auth-redirect'
import { useCurrentBreakpoint } from 'src/hooks/use-current-breakpoint'
import { useRouteAnnouncement } from 'src/hooks/use-route-announcement'
import { LoginTopbar } from 'src/pages/LoginPage/LoginTopbar'

type Props = {
  children?: React.ReactNode
}

const DesktopMain = styled.main`
  flex: 1;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
`

const Hero = styled.div`
  width: 100%;
  display: flex;
  overflow: hidden;
  position: relative;
  background: #191919;
`

const MobileMain = styled.main`
  flex: 1;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
`

const AppLandingLayout = ({ children }: Props) => {
  useAuthRedirect()
  useRouteAnnouncement()
  const { isSmallScreen } = useCurrentBreakpoint()

  if (isSmallScreen()) {
    return (
      <Flex vertical>
        <SkipToContent />
        <LoginTopbar />
        <MobileMain id={MAIN_CONTENT_ID} tabIndex={-1}>
          {children}
        </MobileMain>
      </Flex>
    )
  }

  return (
    <Flex>
      <SkipToContent />
      <DesktopMain id={MAIN_CONTENT_ID} tabIndex={-1}>
        {children}
      </DesktopMain>
      <section className="align-center relative flex h-screen flex-1 justify-center bg-[#191919]">
        <Hero>
          <Flex justify="center" align="center" flex={1}>
            <Logo color={LogoColor.White} width={397} height={163} className="z-1" />
          </Flex>
        </Hero>
      </section>
    </Flex>
  )
}

export default AppLandingLayout
